export enum AvisDirection {
  Right,
  Left,
}
